<template>
    
        <v-row justify="center">
            <v-col cols="12" xl="10">
                <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

                    <div class="watermark">
                        <img v-if="invoiceHeader" :src="getFileServerUrl + employeeDetails?.branch?.company?.watermark" alt="">
                    </div>

                    <div class="letter-container">
                        <div class="letter-content">
                            <table style="width: 100%; border-collapse: collapse;">
                                <thead>
                                    <tr v-if="invoiceHeader">
                                        <td colspan="100%">
                                        <img :src="getFileServerUrl + employeeDetails?.branch?.company?.header_image" style="width: 100%; height: auto;" alt="">
                                        </td>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    <tr>
                                        <td colspan="100%" style="border: none; padding: 25px; vertical-align: top;">
                                            <div style="font-family: sans-serif; font-size: 13px; line-height: 1.6;">
                                                
                                                <div style="margin-bottom: 15px;">
                                                    <p style="margin: 0;"><strong>{{ getCurrentDate }}</strong></p>
                                                </div>

                                                <div style="margin-bottom: 20px;">
                                                    <p style="margin: 0 0 5px 0;"><strong>{{ employeeDetails?.name }}</strong></p>
                                                    <p style="margin: 0;">{{ employeeDetails?.permanent_address }}</p>
                                                </div>

                                                <div style="margin-bottom: 20px; text-align: center;">
                                                    <p style="margin: 0;"><u><strong>LETTER OF APPOINTMENT</strong></u></p>
                                                </div>

                                                <div style="margin-bottom: 15px;">
                                                    <p style="margin: 0;"><strong>Dear {{ employeeDetails?.name }}</strong></p>
                                                </div>

                                                <div style="margin-bottom: 20px;">
                                                    <p style="margin: 0 0 12px 0; text-align: justify;">
                                                        We are pleased to extend an offer for the position of <strong>{{ employeeDetails?.designation?.name }}</strong> at <strong>{{ employeeDetails?.branch?.company?.name }}</strong>, in accordance with the labor laws of Bangladesh and based on your qualifications and interview performance. This offer is effective from <strong>{{ formattedDate(employeeDetails?.general_info?.appointment_date) }}</strong> on the following terms and conditions.
                                                    </p>

                                                    <p style="margin: 0 0 10px 0;"><strong>Position and Department:</strong> You will be appointed as <strong>{{ employeeDetails?.designation?.name }}</strong> in the department of <strong>{{ employeeDetails?.department?.name }}</strong>.</p>

                                                    <p style="margin: 0 0 10px 0;"><strong>Salary and Benefits:</strong> Your starting gross monthly salary will be <strong>BDT {{ employeeDetails?.salary_info?.[0]?.gross_salary }}</strong> and will be subject to applicable taxes and deductions. In addition to your salary, you will be entitled to the following allowances:</p>

                                                    <table style="width: 80%; border-collapse: collapse; margin: 10px auto; border: 1px solid #000;">
                                                        <tbody>
                                                            <tr style="background-color: #f0f0f0;">
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: left; font-weight: bold;">Basic Salary</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">BDT</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">{{ getSalaryDistro?.basic }}%</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">Per month</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">House Rent Allowance</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">BDT</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">{{ getSalaryDistro?.houserent }}%</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">Do</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">Conveyance Allowance</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">BDT</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">{{ getSalaryDistro?.conveyance }}%</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">Do</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">Medical Allowance</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">BDT</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">{{ getSalaryDistro?.medical }}%</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">Do</td>
                                                            </tr>
                                                            <tr style="background-color: #f0f0f0;">
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">Gross Salary</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">BDT</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">{{ employeeDetails?.salary_info[0]?.gross_salary }}</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">Per month</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <p style="margin: 12px 0 10px 0;"><strong>Working Hours:</strong> The Employee's working hours shall be as follows:</p>
                                                    <div style="margin: 0 0 12px 20px;">
                                                        <p style="margin: 0 0 5px 0;">Sunday to Thursday: 9:00 am – 6:00 pm</p>
                                                        <p style="margin: 0;">Lunch Break: 1:00 pm – 2:00 pm</p>
                                                    </div>

                                                    <p style="margin: 0 0 10px 0;"><strong>Probation Period:</strong> Upon commencement of your employment, you will be required to undergo a probationary period of Six (06) months. During this time, the Company will assess your suitability to be confirmed as an employee of the Company. If performance is satisfactory you will be eligible to transfer to the permanent employee if not then further, your job will be separated from the service of the company. At the expiry of the probation period and subject to the Employee being confirmed, the employee will be entitled to Annual/Sick/Others leave as per the company policy after the 6 months confirmation.</p>

                                                    <p style="margin: 0 0 10px 0;"><strong>Termination:</strong> Termination of employment will be in accordance with the prevailing employment laws of Bangladesh. Termination may result from poor performance, policy violations, misconduct, insubordination, or attendance issues. Falsification, theft, conflict of interest, incompetence, and breach of confidentiality are also grounds for termination. Additionally, downsizing or restructuring may lead to workforce reduction in compliance with legal requirements.</p>

                                                    <p style="margin: 0 0 10px 0;"><strong>Notice Period:</strong> A probationary employee may be terminated from his/her service by the Company without any reasons or causes whatsoever without prior notice. In a period of probation with 30 days' notice an employee can resign from the post. Although Management has the right to approve it less than 30 days subject to the company release policy.</p>

                                                    <p style="margin: 0 0 10px 0;"><strong>Leave Entitlement:</strong> After the confirmation you will be entitled the below leaves:</p>
                                                    <div style="margin: 0 0 12px 20px;">
                                                        <p v-for="(leave, idx) in leaveTypesData" :key="idx" style="margin: 0 0 8px 0;">• <strong>{{ leave?.name }}:</strong> {{ leave?.remarks }}</p>
                                                    </div>

                                                    <p style="margin: 0 0 12px 0; text-align: justify;">
                                                        Please review the attached terms and conditions for further details. We look forward to welcoming you to {{ employeeDetails?.branch?.company?.name }} and are confident that your skills and experience will contribute significantly to our team.
                                                    </p>

                                                    <p style="margin: 0 0 12px 0; text-align: justify;">
                                                        You are welcome to our company <strong>{{ employeeDetails?.branch?.company?.name }}</strong> and wish you all the best.
                                                    </p>
                                                </div>

                                                <div style="margin-bottom: 20px;">
                                                    <p style="margin: 0;">Sincerely,</p>
                                                </div>

                                                <div :style="{marginBottom: '30px', marginTop: withSignature? '0': '100px' }" >
                                                    <img v-if="withSignature" :src="`${getFileServerUrl}` + 'uploads/images/company/signature-without-bg.png'" style="width: 150px; height: 60px;" alt="">
                                                    <div style="border-bottom: 1px solid #000; margin: 0 0 8px 0; width: 200px;"></div>
                                                    <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">AUTHORIZED SIGNATURE</div>
                                                    <p style="margin: 5px 0 0 0;"><strong>{{ employeeDetails?.branch?.company?.company_owner_name }}</strong></p>
                                                    <p style="margin: 0;"><strong>{{ employeeDetails?.branch?.company?.owner_designation?.name }}</strong></p>
                                                    <p style="margin: 0;"><strong>{{ employeeDetails?.branch?.company?.name }}</strong></p>
                                                </div>

                                                <div style="margin-top: 20px; border-top: 2px solid #000; padding-top: 20px;">
                                                    <p style="margin: 0 0 15px 0; text-align: center;"><u><strong>ACCEPTANCE OF EMPLOYMENT</strong></u></p>
                                                    <p style="margin: 0 0 15px 0; text-align: justify;">
                                                        I, Mr. {{ employeeDetails?.name }} the undersigned, have read the foregoing and fully understood and accept the terms and conditions of employment as stipulated herein. I will join on <strong>{{ employeeDetails?.joining_date }}</strong>.
                                                    </p>

                                                    <div style="margin-top: 30px;">
                                                        <p style="margin: 0 0 40px 0;"><strong>Signature:</strong></p>
                                                        <p style="margin: 0;"><strong>Date:</strong></p>
                                                    </div>
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr v-if="invoiceHeader">
                                        <td colspan="100%" style="border:none">
                                        <div style="width:100%;height: 100px;">&nbsp;</div>
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>
                        </div>

                        <div class="invoice-footer">
                            <img v-if="invoiceHeader" :src="getFileServerUrl + employeeDetails?.branch?.company?.footer_image" alt="" style="width: 100%; display: block; margin-bottom:-15px;">
                        </div>
                    </div>

                </v-sheet>
            </v-col>
            <v-col cols="12">
                <v-checkbox
                label="With signature"
                v-model="withSignature"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                :true-value="1"
                :false-value="0"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" style="display: flex; justify-content: end;" >
                <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
                    Print without pad
                </v-btn>
                <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
                    Print with pad
                </v-btn>
            </v-col>
        </v-row>
    
</template>

<script>
export default {
    name: "hrm-employee-appointment-letter",
    props: {
        employeeDetails: Object,
        getFileServerUrl: String,
        getCurrentDate: String,
        formattedDate: String,
        id: Number,
    },
    data() {
        return {
            withSignature:1,
            leaveTypesData: null,
            invoiceHeader: true,
            pagePadding: 0,
        };
    },
    created() {
        // if (!this.$store.getters.getHrmEmployeeSalaryDistribution) {
            this.$store.dispatch("getHrmEmployeeSalaryDistribution");
        // }
    },
    computed: {
        getSalaryDistro() {
            const salaryDistro = this.$store.getters.getHrmEmployeeSalaryDistribution;
            return salaryDistro;
        },
    },
    methods: {
        print(isPad) {
            if (isPad === 1) {
                this.invoiceHeader = true;
                this.pagePadding = 0;
            } else if (isPad === 0) {
                this.invoiceHeader = false;
                this.pagePadding = 80;
            }

            setTimeout(() => {
                
                const printContent = document.getElementById("printable-area").innerHTML;
                const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
    
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Appointment Letter</title>
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
    
                    @page {
                        size: A4;   
                        margin: ${this.pagePadding}px 0;
                    }

                    html, body {
                        margin: 0;
                        padding: 0;
                        width: 100%;
                        height: auto;
                    }
    
                    body { 
                        font-family: sans-serif; 
                        background: #fff; 
                        color: #000; 
                        -webkit-print-color-adjust: exact; 
                        print-color-adjust: exact;
                        margin: 0;
                        padding: 0;
                    }
    
                    .report-paper { 
                        width: 100%; 
                        padding: 0 !important;
                        background: #fff;
                        margin: 0;
                    }
    
                    .letter-container {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                    }
    
                    .letter-content {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        overflow: visible;
                    }
    
    
                    table {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        border-collapse: collapse;
                    }
    
                    thead {
                        display: table-header-group;
                        page-break-inside: avoid;
                    }
    
                    .invoice-footer {
                        margin-top: auto;
                        position: fixed;
                        left; 0;
                        bottom: 15px;
                        width: 100%;    
                    }
    
                    tbody {
                        page-break-inside: avoid;
                    }
    
                    .watermark {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 0;
                    }
    
                    img { 
                        max-width: 100% !important; 
                        height: auto !important; 
                        display: block;
                    }
    
                    .text-center { text-align: center; }
                    .text-right { text-align: right; }
                    .text-left { text-align: left; }
                    
                    .mt-4 { margin-top: 16px !important; }
                    .pa-6 { padding: 24px !important; }
    
                    .d-print-none {
                        display: none !important;
                    }
    
                    @media print { 
                        body {
                            margin: 0;
                            padding: 0;
                        }
    
                        .report-paper {
                            margin: 0;
                            padding: 0;
                        }
    
                        thead {
                            display: table-header-group;
                            page-break-inside: avoid;
                            page-break-after: avoid;
                        }
    
                        tfoot {
                            display: table-footer-group;
                            page-break-inside: avoid;
                            page-break-before: avoid;
                        }
    
                        tbody {
                            page-break-inside: avoid;
                        }
    
                        table {
                            page-break-inside: auto;
                        }
    
                        tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
    
                        .watermark {
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            z-index: 0;
                        }
                    }
                    </style>
                    </head>
                    <body>
                        ${printContent}
                    </body>
                    </html>
                `);
    
                printWindow.document.close();
                printWindow.focus();

                setTimeout(() => {
                    printWindow.print()
                }, 500);
                this.invoiceHeader = true;
                this.pagePadding = 0;
            }, 500);
        }
    },
    mounted() {
        this.$store.dispatch("getLeaveTypeList", { employee_id: this.id }).then((res) => {
            this.leaveTypesData = res.data.data;
        })
    },
};
</script>

<style scoped>
body, html {
    font-family: sans-serif;
}
.full-height { 
    min-height: 60vh; 
}
.grey-lighten-3 { 
    background-color: #eeeeee !important; 
}
.report-paper { 
    background: white; 
}
.letter-container { 
    width: 100%; 
}
.text-center { 
    text-align: center; 
}
.text-right { 
    text-align: right; 
}
.text-left { 
    text-align: left; 
}
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.justify-end{
    justify-content:flex-end;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>